<div class="content">
  <ng-content></ng-content>
  <div class="pmi-logo"><img  src="/assets/img/game/pmi-logo.svg"></div>
</div>
